import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import { Component } from "@/decorators";
import TipoCliente from "@/models/enum/tipoCliente";
import TipoLogEntidade from "@/models/enum/tipoLogEntidade";
import TiposFranquia from "@/models/enum/tiposFranquia";
import { TipoVendaClienteModel } from "@/models/tipoVendaClienteModel";
import TipoVendaModel from "@/models/tipoVendaModel";
import naturezaOperacaoService from "@/services/naturezaOperacaoService";
import tipoVendaService from "@/services/tipoVendaService";
import { BaseOption } from "@/types/options";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        buttonIncluirComponent,
        checkboxComponent,
        comboComponent,
        dataTooltipComponent,
        fieldsetComponent,
        gridComponent,
        logEntidadeComponent,
    },
})
export default class TipoVendaEditComponent extends EditComponentBase<TipoVendaModel> {
    private isAdmin = false;
    private tipoLogEntidade = TipoLogEntidade.TipoVenda;
    private franquiaGrupoAtlas = false;
    private franquiaFracionadora = false;
    private tipoClientePermitidoId: TipoCliente | null = null;

    private gridColumnsTiposClientesPermitidos: Array<GridColumn> = [
        new GridColumn("tipoClienteDescricao", "Tipo Cliente", GridColumnType.String),
    ];

    private tiposClientesOptions: Array<{ text: string; value: TipoCliente }> = [
        { text: "Normal", value: TipoCliente.Normal },
        { text: "Franquia", value: TipoCliente.Franquia },
        { text: "Filial", value: TipoCliente.Filial },
        { text: "Própria empresa", value: TipoCliente.PropriaEmpresa },
    ];

    get tiposClientesPermitidosOptions() {
        const tiposClientesSelecionados = this.model?.tiposClientesPermitidos?.map(p => p.tipoCliente) ?? [];

        return this.tiposClientesOptions.filter(p => !tiposClientesSelecionados.includes(p.value));
    }
    private naturezaOperacaoOptions: BaseOption[] = [];

    private async beforeMount() {
        await this.setPropsCached(tipoVendaService, "tipovenda", new TipoVendaModel(), false, true);

        this.isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        this.naturezaOperacaoOptions = await naturezaOperacaoService.comboCached(this.usuarioLogado.franquiaId!);
        this.franquiaGrupoAtlas = this.usuarioLogado.franquia?.franquiaGrupoAtlas;
        this.franquiaFracionadora = this.usuarioLogado.franquia?.tipoFranquia == TiposFranquia.Fracionadora;
    }

    private onInclusaoTipoClientePermitido() {
        this.garantirTiposClientesPermitidos();

        if (this.tipoClientePermitidoId == null) {
            return;
        }

        if (this.model.tiposClientesPermitidos.some(p => p.tipoCliente == this.tipoClientePermitidoId)) {
            return this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.tipoClientePermitidoJaIncluido"));
        }

        const tipoCliente = new TipoVendaClienteModel();
        tipoCliente.tipoVendaId = this.model.id ?? 0;
        tipoCliente.tipoCliente = this.tipoClientePermitidoId;
        tipoCliente.tipoClienteDescricao = this.getTipoClienteDescricao(this.tipoClientePermitidoId);

        this.model.tiposClientesPermitidos.push(tipoCliente);
        this.tipoClientePermitidoId = null;
    }

    private onRemoveTipoClientePermitido(model: TipoVendaClienteModel) {
        this.garantirTiposClientesPermitidos();
        this.model.tiposClientesPermitidos = this.model.tiposClientesPermitidos.filter(p => p != model);
    }

    private garantirTiposClientesPermitidos() {
        if (!this.model.tiposClientesPermitidos) {
            this.model.tiposClientesPermitidos = [];
        }

        this.model.tiposClientesPermitidos.forEach(tipoCliente => {
            tipoCliente.tipoClienteDescricao = this.getTipoClienteDescricao(tipoCliente.tipoCliente);
        });
    }

    private getTipoClienteDescricao(tipoCliente: TipoCliente) {
        return this.tiposClientesOptions.find(p => p.value == tipoCliente)?.text ?? "";
    }
}
